import { render, staticRenderFns } from "./DateList.vue?vue&type=template&id=8464d396&scoped=true"
import script from "./DateList.vue?vue&type=script&lang=js"
export * from "./DateList.vue?vue&type=script&lang=js"
import style0 from "./DateList.vue?vue&type=style&index=0&id=8464d396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8464d396",
  null
  
)

export default component.exports